module.exports = __webpack_public_path__ + "static/media/DreamHouseLogo.9ea7915e.webp";